// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-showcase {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
  justify-items: center;
  width: 100%;
  height: calc(100dvh - 200px);
  overflow-y: auto;
}

.scrollable::-webkit-scrollbar-track {
  background-color: inherit !important; /* Inherit the background color of the track */
}

.MuiTypography-root.type-text{
  color: #9D9FB2;
  font-family: var(--font-family-primary);
  font-weight: 600;
  font-size: 15px
}
.MuiTypography-root.type-color{
  color: #fff;
  font-family: var(--font-family-primary);
  font-weight: 600;
  font-size: 15px
}

.MuiButtonBase-root.type-button {
  border-radius: 5px;
  text-transform: none;
  font-weight: 600;
  margin-bottom: 1px;
  background-color: #3F3589;
  color: #fff;
  font-size: 10px;
  padding: 3px 10px;
  font-family: var(--font-family-primary);
}
.MuiTypography-root.search-text{
  font-family: 'var(--font-family-primary)';
  font-weight: 400;
  font-size: 15px;
}
.showCaseAddModelContainer{
  padding: 0px 24px;
}
.MuiGrid-root.showcaseHeader{
   display: flex;
  align-items: flex-start;
  margin-top: 10px;
  flex-direction: column;
}
.MuiGrid-root.showcaseFilter{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.MuiFormGroup-root.form-type-radio .MuiFormControlLabel-root .MuiTypography-root{
  color: #fff;
}
.MuiFormGroup-root.radio-group .MuiFormControlLabel-root .MuiTypography-root{
  color: #fff;
}
.titleContainer{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 768px){
  .MuiGrid-root.showcaseHeader{
  align-items: center;
 flex-direction: row;
}
.MuiGrid-root.showcaseFilter{
  justify-content: flex-end;
  gap: 20px;
}

}
@media screen and (min-width: 1024px){
  .voiceSelectorContainer{
    width: 90%;
     margin-bottom: 20px;
  }
}
@media screen and (min-width: 1440px){
  .voiceSelectorContainer{
  width: 70%;
  margin-bottom: 20px;
}
} 


`, "",{"version":3,"sources":["webpack://./src/components/Showcase/Showcase.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC,EAAE,8CAA8C;AACtF;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB;AACF;AACA;EACE,WAAW;EACX,uCAAuC;EACvC,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;GACG,aAAa;EACd,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE;EACA,mBAAmB;CACpB,mBAAmB;AACpB;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;AACA;EACE;IACE,UAAU;KACT,mBAAmB;EACtB;AACF;AACA;EACE;EACA,UAAU;EACV,mBAAmB;AACrB;AACA","sourcesContent":[".featured-showcase {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 20px;\n  justify-items: center;\n  width: 100%;\n  height: calc(100dvh - 200px);\n  overflow-y: auto;\n}\n\n.scrollable::-webkit-scrollbar-track {\n  background-color: inherit !important; /* Inherit the background color of the track */\n}\n\n.MuiTypography-root.type-text{\n  color: #9D9FB2;\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  font-size: 15px\n}\n.MuiTypography-root.type-color{\n  color: #fff;\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  font-size: 15px\n}\n\n.MuiButtonBase-root.type-button {\n  border-radius: 5px;\n  text-transform: none;\n  font-weight: 600;\n  margin-bottom: 1px;\n  background-color: #3F3589;\n  color: #fff;\n  font-size: 10px;\n  padding: 3px 10px;\n  font-family: var(--font-family-primary);\n}\n.MuiTypography-root.search-text{\n  font-family: 'var(--font-family-primary)';\n  font-weight: 400;\n  font-size: 15px;\n}\n.showCaseAddModelContainer{\n  padding: 0px 24px;\n}\n.MuiGrid-root.showcaseHeader{\n   display: flex;\n  align-items: flex-start;\n  margin-top: 10px;\n  flex-direction: column;\n}\n.MuiGrid-root.showcaseFilter{\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.MuiFormGroup-root.form-type-radio .MuiFormControlLabel-root .MuiTypography-root{\n  color: #fff;\n}\n.MuiFormGroup-root.radio-group .MuiFormControlLabel-root .MuiTypography-root{\n  color: #fff;\n}\n.titleContainer{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n@media screen and (min-width: 768px){\n  .MuiGrid-root.showcaseHeader{\n  align-items: center;\n flex-direction: row;\n}\n.MuiGrid-root.showcaseFilter{\n  justify-content: flex-end;\n  gap: 20px;\n}\n\n}\n@media screen and (min-width: 1024px){\n  .voiceSelectorContainer{\n    width: 90%;\n     margin-bottom: 20px;\n  }\n}\n@media screen and (min-width: 1440px){\n  .voiceSelectorContainer{\n  width: 70%;\n  margin-bottom: 20px;\n}\n} \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
